import { ApprovalStatus, Document } from "@/app/types/generated/graphql";

/**
 * Converts document object into only status for validation checking
 */
export const convertToDocumentStatus = (document: Document) => ({
  status: document?.status,
  approvalStatus: document.approvalState?.status ?? ApprovalStatus?.NotRequested,
});
